import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { IProfileBioAddRequest } from '@core/interfaces/i-profile-bio';

@Injectable({
  providedIn: 'root'
})
export class ProfileBioService {

  constructor(private data: DataService) { }

  add(formData: FormData, message?: string): Observable<any> {
    return this.data.post('profile-bio/save', formData, message);
  }

  updateOrder(payload: any, message?: string): Observable<any> {
    return this.data.post('profile-bio/order', payload, message);
  }

  edit(payload: IProfileBioAddRequest[], message?: string) {
    return this.data.put('profile-bio/update', payload, message);
  }

  delete(id: number, message?: string): Observable<any> {
    return this.data.delete(`profile-bio?id=${id}`, message);
  }
}
